module.exports = __webpack_public_path__ + "img/empty.46508290.png";